"use strict";

// Expose all js classes here.
require('./js/dgs-burgermenu');